import { get } from '@/utils/request';

export const friend_links = (params) => {
  return get('/api/v1/friend_links', params);
};
